import { lazy } from 'react';
import Loadable from '../../components/Loadable';

const PaidReceipt = Loadable(lazy(() => import('./PaidReceipt')));

const ReportRoutes = [
  { path: '/paidreceipt', element: <PaidReceipt /> },
];

export default ReportRoutes;
